export const ELEMENT_TYPE_SECTION_GROUP = 'sectionGroup';

export const ELEMENT_TYPE_ARTICLE = 'article';

export const ELEMENT_TYPE_PICTURE = 'picture';

export const ELEMENT_TYPE_TEASER = 'teaser';

export const ELEMENT_TYPE_SOCIAL_LINKS = 'socialLinks';

export const ELEMENT_TYPE_NAVIGATION_SECTION = 'navigationSection';
